import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";

export function PrimaryBtn({ to, children, testid, onClick, type }) {
  const cls =
    "group inline-flex items-center justify-center gap-3 bg-brand px-8 py-4 font-display text-[13px] font-bold uppercase tracking-[0.12em] text-white transition-colors duration-200 hover:bg-branddark";
  if (to) {
    return (
      <Link to={to} data-testid={testid} className={cls} onClick={onClick}>
        {children}
        <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
      </Link>
    );
  }
  return (
    <button type={type || "submit"} data-testid={testid} className={cls} onClick={onClick}>
      {children}
      <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
    </button>
  );
}

export function GhostBtn({ to, children, testid }) {
  return (
    <Link
      to={to}
      data-testid={testid}
      className="group inline-flex items-center justify-center gap-3 border border-ink/20 bg-white px-8 py-4 font-display text-[13px] font-bold uppercase tracking-[0.12em] text-ink transition-colors duration-200 hover:border-brand hover:text-brand"
    >
      {children}
      <ArrowUpRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
    </Link>
  );
}
